<template>
  <div>
    <el-form v-if="verifyStep === 1" :model="sendCodeForm" :rules="sendCodeRules" ref="sendCodeForm">
      <el-row class="w-100 mxw-md">
        <el-col :span="24" class="break-word">
          <div>For your security we’ll send a verification code to confirm your identity.</div>
          <div>Please select an option below to verify:</div>
        </el-col>
        <el-col :span="24" class="mt-05">
          <el-form-item prop="type">
            <el-radio-group v-model="sendCodeForm.type">
              <el-radio class="mt-05" v-if="data.member.profile.mobile" label="mobile" >Mobile ({{ data.member.profile.mobile }})</el-radio><br/>
              <el-radio class="mt-05" v-if="data.member.profile.email" label="email" >Email ({{ data.member.profile.email }})</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mt-15">
        <el-col class="text-right">
          <!-- <el-button
            @click="cancel"
          >Cancel</el-button> -->
          <el-button
            type="primary"
            class="btn-highlight"
            @click="sendCode"
          >Send Code</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-form v-if="verifyStep === 2" :model="verifyCodeForm" :rules="verifyCodeRules" ref="verifyCodeForm">
      <el-row class="w-100 mxw-md" :gutter="20">
        <el-col :span="24" class="mb-05">
          <div v-if="sendCodeForm.type === 'mobile'">A verification code has been send to mobile ({{ data.member.profile.mobile }})</div>
          <div v-if="sendCodeForm.type === 'email'">A verification code has been send to email ({{ data.member.profile.email }})</div>
          <div>Please enter the code below to verify:</div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <el-form-item prop="code">
            <el-input v-model="verifyCodeForm.code" placeholder="Type here..." />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <el-button type="primary" class="btn-highlight" @click="verifyCode">Verify</el-button>
          <el-button type="primary" class="btn-highlight" @click="resendCode">Resend Code</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'VerifyMember',
  props: {
    data: Object // { member }
  },
  data() {
    return {
      verifyStep: 1,
      sendCodeForm: {
        type: ''
      },
      sendCodeRules: {
        type: [
          { required: true, message: 'Please select a verify option', trigger: 'blur' }
        ]
      },
      verifyCodeForm: {
        code: ''
      },
      verifyCodeRules: {
        code: [
          { required: true, message: 'Verification code is required', trigger: 'blur' }
        ]
      },
    };
  },
  methods: {
    cancel() {
      this.$emit('updateVisible', false);
    },
    sendCode() {
      this.$refs.sendCodeForm.validate((valid) => {
        if (valid) {
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.post(`/assemble/api/v1/account/portal/members/${this.data.member._id}/link/verification-code`, {
            type: this.sendCodeForm.type
          }).then(() => {
            this.verifyStep = 2;
            this.$store.commit('loading', false);
          }).catch((e) => {
            this.$message.error(e.response.data.message);
            this.$store.commit('loading', false);
          });
        }
      });
    },
    verifyCode() {
      this.$refs.verifyCodeForm.validate((valid) => {
        if (valid) {
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.put(`/assemble/api/v1/account/portal/members/${this.data.member._id}/link`, {
            code: this.verifyCodeForm.code
          }).then(() => {
            this.$emit('updateVisible', false);
            this.$emit('refreshMembers');
            this.$message({ message: 'Member linked successfully', type: 'success' });
            this.$store.commit('loading', false);
          }).catch((e) => {
            this.$message.error(e.response.data.message);
            this.$store.commit('loading', false);
          });
        }
      });
    },
    resendCode() {
      this.verifyStep = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-radio {
  white-space: normal !important;
}
</style>
